import {Component, Input} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import * as moment from 'moment';
import {AccreditedService} from '@app/accredited/accredited.service';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {createAutoCorrectedDatePipe} from 'text-mask-addons/dist/textMaskAddons'

@Component({
  selector: 'app-accredited-modal-content',
  templateUrl: './accredited-modal.html'
  // template: `
  //   <div class="modal-header">
  //     <h4 class="modal-title">Hi there!</h4>
  //     <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
  //       <span aria-hidden="true">&times;</span>
  //     </button>
  //   </div>
  //   <div class="modal-body">
  //     <p>Hello!</p>
  //     <input type="text" id="focusMe" />
  //   </div>
  //   <div class="modal-footer">
  //     <button type="button" class="btn btn-outline-dark" (click)="activeModal.close('Close click')">Close</button>
  //   </div>
  // `
})
export class AccreditedModalContentComponent {
  @Input() selectedAccredited: any;
  addCupomForm: FormGroup;
  totalValue: number;
  message: string = null;
  qrcode: string = null;
  code: string = null;
  isLoading: boolean | false;
  cpf: string = null;
  date: string = moment(new Date()).format('DD/MM/YYYY');
  cpfMask = [
    /[0-9]/, /[0-9]/, /[0-9]/, '.',
    /[0-9]/, /[0-9]/, /[0-9]/, '.',
    /[0-9]/, /[0-9]/, /[0-9]/, '-',
    /[0-9]/, /[0-9]/];
  birthMask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  autoCorrected: any;

  constructor(
    private formBuilder: FormBuilder,
    private accreditedService: AccreditedService,
    public activeModal: NgbActiveModal
    ) {
    this.createForm();
    this.clearForm();
    this.autoCorrected = createAutoCorrectedDatePipe('dd/mm/yyyy');
  }

  addCupom() {
    const receipt = this.addCupomForm.value;
    receipt.accredited = this.selectedAccredited.accredited;
    receipt.date = moment(moment(`${this.date} ${moment(new Date()).format('HH:mm')}`, 'DD/MM/YYYY HH:mm')
      .toDate()).format('YYYY/MM/DD HH:mm:ss');
    receipt.value = this.totalValue.toString();
    console.log(receipt);

    this.accreditedService.addReceipt(receipt).subscribe( result => {
      console.log('Registro inserido!', result);
      if (!result.qrcode) {
        this.message = 'Erro ao gerar QR-code, verifique os dados.';
        return false;
      }
      this.qrcode = result.qrcode;
      this.code = result.code;
      return true;
    }, error => {
      console.log('Erro ao inserir', error);
      return false;
    });
  }

  clearForm() {
    this.message = null;
    this.qrcode = null;
    this.code = null;
    this.addCupomForm.reset();
    this.totalValue = null;
  }

  private createForm() {
    this.addCupomForm = this.formBuilder.group({
      name: ['', Validators.required],
      cpf: ['', Validators.required],
      date: ['', Validators.required],
      value: ['', Validators.required],
      operator: ['', Validators.required]
    });
  }
}



// WEBPACK FOOTER //
// d:/workspace/wynk_web_shoppings_3_prod/src/app/accredited-modal/accredited-modal.component.ts